var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4444_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8483 0H0.848343C-0.212523 0 -1.22994 0.421427 -1.98008 1.17157C-2.73023 1.92172 -3.15166 2.93913 -3.15166 4L-3.15166 7H32.8483V4C32.8483 2.93913 32.4269 1.92172 31.6768 1.17157C30.9266 0.421427 29.9092 0 28.8483 0Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.30499 22C-4.30499 23.0609 -3.88357 24.0783 -3.13342 24.8284C-2.38327 25.5786 -1.36586 26 -0.304993 26H27.695C28.7559 26 29.7733 25.5786 30.5234 24.8284C31.2736 24.0783 31.695 23.0609 31.695 22V19H-4.30499V22Z",
    fill: "#078930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 7H35V19H-1V7Z",
    fill: "#DA121A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 7H35V9H-1V7ZM-1 17H35V19H-1V17Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.43316 -0.322571C-1.30241 0.491489 -1.84976 1.68093 -1.84976 3.30127V23.2918C-1.84976 24.3202 -1.30241 25.5097 -0.43316 26.3226L16.5 13L-0.43316 -0.322571Z",
    fill: "#0F47AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.249 12.917L9.026 10.471L6.151 11.405L4.375 8.96002V11.983L1.5 12.917L4.375 13.851V16.873L6.151 14.428L9.026 15.362L7.249 12.917Z",
    fill: "#FCDD09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4444_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/ss.45d818ea955f9bf7e9392d64062c6fdb.svg";
export { ForwardRef as ReactComponent };